<template>
    <div class="container dashboard">
        <MenuAdmin />

        <Modal v-if="showModal" :closeModal="toggleModal">
            <h4 class="text-center">Agregar nueva oferta</h4>
            <form class="p-3" v-on:submit.prevent="onSubmit">
                <div class="row d-flex justify-content-center">
                    <div class="col">
                        <div class="form-group">
                            <label for=""><strong>Nombre</strong></label>
                            <input type="text" class="form-control" placeholder="Nombre" v-model="nombre" required />
                        </div>
                        <div class="form-group">
                            <label for=""><strong>Orden</strong></label>
                            <input type="text" class="form-control" placeholder="Orden" v-model="order" required />
                        </div>

                        <div class="form-group">
                            <label for=""><strong>URL</strong></label>
                            <input type="url" class="form-control" placeholder="Url" v-model="url" />
                        </div>
                        <div>
                            <label for=""><strong>Imagen Desktop</strong></label>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" @change='handleFilePcChange' id="imagen"
                                    accept='image/*' required lang="es">
                                <label class="custom-file-label" for="image">Seleccionar Archivo</label>
                            </div>
                        </div>
                        <div class="mt-3">
                            <label for=""><strong>Imagen Mobile</strong></label>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" @change='handleFileMoChange' id="imagen"
                                    accept='image/*' required lang="es">
                                <label class="custom-file-label" for="image">Seleccionar Archivo</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row d-flex  justify-content-center">
                    <div class="col-md-6 d-flex justify-content-center">
                        <button type="submit" class="primary-btn mt-4">
                            <i class="fa fa-upload mr-2" aria-hidden="true"></i>Agregar
                        </button>
                    </div>
                </div>
            </form>
        </Modal>

        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="d-flex  justify-content-between align-items-center mb-4">
                    <h4 class="mb-0">
                        Ofertas publicadas
                    </h4>
                    <button @click="toggleModal()" class="primary-btn">
                        <i class="fa fa-upload mr-2" aria-hidden="true"></i>Agregar
                    </button>
                </div>
                <div class="row">
                    <!-- Card offer -->
                    <div class="col-md-6 col-12 side-offer-container" v-for="(item, index) in productos" :key="item.id">

                        <Modal v-if="modalIndex === index" :close-modal="toggleEditModal">
                            <h4 class="text-center">Editar oferta</h4>
                            <form class="p-3" v-on:submit.prevent="updateData(item)">
                                <div class="row d-flex justify-content-center">
                                    <div class="col">
                                        <div class="form-group">
                                            <label for=""><strong>Nombre</strong></label>
                                            <input type="text" class="form-control" :placeholder="item.nombre"
                                                v-model="nombre" />
                                        </div>
                                        <div class="form-group">
                                            <label for=""><strong>URL</strong></label>
                                            <input type="url" class="form-control" :placeholder="item.url"
                                                v-model="url" />
                                        </div>
                                        <div class="form-group">
                                            <label for=""><strong>Orden</strong></label>
                                            <input type="order" class="form-control" :placeholder="item.order"
                                                v-model="order" />
                                        </div>
                                        <div class="d-flex">
                                            <div class="mr-2">
                                                <div>
                                                    <p><strong>Imagen Actual Desktop</strong></p>
                                                    <div class="img-container mb-3">
                                                        <img :src="item.imgPc" :alt="item.nombre" class="">
                                                    </div>
                                                </div>
                                                <div class="custom-file">
                                                    <input type="file" class="custom-file-input"
                                                        @change='handleFilePcChange' id="imagen" accept='image/*'
                                                        lang="es">
                                                    <label class="custom-file-label" for="image">Seleccionar
                                                        Archivo</label>
                                                </div>
                                            </div>

                                            <div class="ml-2">
                                                <div>
                                                    <p><strong>Imagen Actual Mobile</strong></p>
                                                    <div class="img-container mb-3">
                                                        <img :src="item.imgMo" :alt="item.nombre" class="">
                                                    </div>
                                                </div>
                                                <div class="custom-file">
                                                    <input type="file" class="custom-file-input"
                                                        @change='handleFileMoChange' id="imagen" accept='image/*'
                                                        lang="es">
                                                    <label class="custom-file-label" for="image">Seleccionar
                                                        Archivo</label>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row d-flex  justify-content-center">
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <button type="submit" class="primary-btn mt-4">
                                            <i class="fa fa-pencil  mr-2" aria-hidden="true"></i>Editar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </Modal>

                        <div class="side-offer">
                            <div class="icon-container">
                                <button type="button" class="danger-icon-btn" @click="deleteData(item.id)">
                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="edit-icon-btn ml-2" @click="toggleEditModal(index)">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="info-container">
                                <div class="d-flex">
                                    <div class="mr-4">
                                        <p class="mb-0"><strong>Nombre</strong></p>
                                        <p>{{ item.nombre }}</p>
                                    </div>

                                    <div>
                                        <p class="mb-0"><strong>URL Oferta</strong></p>
                                        <p>{{ item.url }}</p>
                                    </div>

                                </div>
                                <div class="d-flex">
                                    <div class="mr-4">
                                        <p class="mb-0"><strong>Orden</strong></p>
                                        <p class="neutral-pill">{{ item.order }}</p>
                                    </div>


                                    <div>
                                        <p class="mb-0"><strong>Visitas</strong></p>
                                        <p class="neutral-pill">{{ item.count }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex">
                                <div class="mr-md-1">
                                    <p><strong>Imagen Desktop</strong></p>
                                    <div class="img-container">
                                        <img :src="item.imgPc" alt="" />
                                    </div>
                                </div>
                                <div class="ml-md-1">
                                    <p><strong>Imagen Mobile</strong></p>
                                    <div class="img-container">
                                        <img :src="item.imgMo" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- card offer -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MenuAdmin from '../components/MenuAdmin.vue';
import fire from "./../fire";
import Swal from 'sweetalert2';
import Modal from '../components/Modal.vue';

export default {
    name: "AdminSideOffer",
    components: { MenuAdmin, Modal },
    data() {
        return {
            showModal: false,
            productos: [],
            nombre: "",
            imagen: null,
            url: "",
            order: "",
            moHide: null,
            modalIndex: null,
            imgMo: null,
            imgPc: null,
            updates: [],
            count: 0
        };
    },
    methods: {
        toggleEditModal(index) {
            this.modalIndex = this.modalIndex === index ? null : index;
        },

        toggleModal() {

            if (this.showModal === false) {
                this.showModal = true;
            } else {
                this.showModal = false;
            }

            console.log(this.showModal)
        },
        deleteData(id) {
            Swal.fire({
                title: "¿Estas seguro de que quieres eliminar la oferta?",
                text: "No podrás revertir esta acción mas adelante",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar!",
                confirmButtonText: "Si, Eliminar!",
            }).then((result) => {
                if (result.isConfirmed) {
                    const idToDelete = id;
                    const offerToDelete = fire.database().ref(`side_offers/${idToDelete}`);
                    offerToDelete.remove()
                        .then(() => {
                            console.log('Objeto con id: ' + id + '  eliminaddo correctamente');
                            Swal.fire({
                                didOpen: () => {
                                    Swal.hideLoading();
                                },
                                title: 'Oferta Eliminada',
                                text: 'Se elimino la oferta con éxito',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1000,
                            }, function () {
                                Swal.close();
                            });
                        })
                        .catch((error) => {
                            console.log('Hubo un error: ' + error);
                        })
                }
            })

        },

        handleFilePcChange(e) {
            this.imgPc = e.target.files[0];
            console.log('imagen pc seleccionada: ' + this.imgPc.name);
        },
        handleFileMoChange(e) {
            this.imgMo = e.target.files[0];
            console.log('imagen mo seleccionada: ' + this.imgMo.name);
        },
        onSubmit() {
            console.log("sending data");
            this.saveData();
        },
        fetchData() {
            const sideOffersRef = fire.database().ref('side_offers');
            // .once solo recibe una ves la data en cambio .on la recibe en tiempo real
            sideOffersRef.on('value', (snapshot) => {
                const data = snapshot.val()
                if (data) {
                    //  Here i can assign the data whit the object id included
                    this.productos = Object.keys(data).map(id => ({ id, ...data[id] }))
                }
                //console.log(this.productos)
            })
        },
        saveData() {
            if (!this.imgPc || !this.imgMo) {
                alert('Debes seleccionar ambas imagen');
                return;
            }
            Swal.fire({
                title: 'Subiendo oferta...',
                html: 'Por favor espera...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });
            const date = +new Date().getTime()
            const imagenPcRef = fire.storage().ref().child(`side-offers/${date}-${this.imgPc.name}-pc`)

            imagenPcRef.put(this.imgPc).then(() => {
                imagenPcRef.getDownloadURL().then((imgPcUrl) => {
                    const imagenMoRef = fire.storage().ref().child(`side-offers/${date}-${this.imgMo.name}-mo`)
                    imagenMoRef.put(this.imgMo).then(() => {
                        imagenMoRef.getDownloadURL().then((imgMoUrl) => {
                            const producto = {
                                nombre: this.nombre,
                                url: this.url,
                                order: this.order,
                                imgPc: imgPcUrl,
                                imgMo: imgMoUrl,
                                count: this.count
                            };
                            fire
                                .database()
                                .ref("side_offers")
                                .push(producto);
                            this.nombre = "";
                            this.url = "";
                            this.order = ""
                            this.imgPc = null;
                            this.imgMo = null;
                            console.log("Producto guardado exitosamente.");
                            this.toggleModal()

                            Swal.fire({
                                didOpen: () => {
                                    Swal.hideLoading();
                                },
                                title: 'Oferta publicada',
                                text: 'Se publico la oferta con éxito',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1000,
                            }, function () {
                                Swal.close();
                            });
                        })
                    })


                })
            })


        },
        updateData(item) {
            Swal.fire({
                title: 'Subiendo oferta...',
                html: 'Por favor espera...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });

            const updatedItem = JSON.parse(JSON.stringify(item));

            if (this.nombre !== '') {
                updatedItem.nombre = this.nombre;
            }

            if (this.url !== '') {
                updatedItem.url = this.url;
            }
            if (this.order !== '') {
                updatedItem.order = this.order;
            }
            //if the img is updated then this  is uploaded, and the is writed the data to firestore db
            if (this.imgPc !== null) {
                const date = +new Date().getTime()
                const imgPcRef = fire.storage().ref().child(`side-offers/${date}-${this.imgPc.name}-pc`);

                imgPcRef.put(this.imgPc).then(() => {
                    return imgPcRef.getDownloadURL();
                }).then((imgPcUrl) => {
                    updatedItem.imgPc = imgPcUrl;
                    console.log('Imagen actualizada: ', imgPcUrl);
                    return fire
                        .database()
                        .ref(`side_offers/${updatedItem.id}`)
                        .update(updatedItem);
                }).then(() => {
                    console.log('Datos actualizados en Firebase');
                    Swal.fire({
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        title: 'Oferta actualizada',
                        text: 'Se actualizaron los datos con éxito',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1000,
                    }, function () {
                        Swal.close();
                    });
                    this.nombre = "";
                    this.url = "";
                    this.order = ""
                    this.imgPc = null;
                    this.imgMo = null;

                }).catch((error) => {
                    console.log('Error actualizando la imagen: ' + error);
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un problema al actualizar la oferta. Por favor, inténtalo de nuevo.',
                        icon: 'error',
                    });
                });

            }
            if (this.imgMo !== null) {
                const date = +new Date().getTime()
                const imgMoRef = fire.storage().ref().child(`side-offers/${date}-${this.imgMo.name}-mo`);

                imgMoRef.put(this.imgMo).then(() => {
                    return imgMoRef.getDownloadURL();
                }).then((imgMoUrl) => {
                    updatedItem.imgMo = imgMoUrl;
                    console.log('Imagen actualizada: ', imgMoUrl);
                    return fire
                        .database()
                        .ref(`side_offers/${updatedItem.id}`)
                        .update(updatedItem);
                }).then(() => {
                    console.log('Datos actualizados en Firebase');
                    Swal.fire({
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        title: 'Oferta actualizada',
                        text: 'Se actualizaron los datos con éxito',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1000,
                    }, function () {
                        Swal.close();
                    });
                    this.nombre = "";
                    this.url = "";
                    this.order = ""
                    this.imgPc = null;
                    this.imgMo = null;

                }).catch((error) => {
                    console.log('Error actualizando la imagen: ' + error);
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un problema al actualizar la oferta. Por favor, inténtalo de nuevo.',
                        icon: 'error',
                    });
                });

            } else {
                fire
                    .database()
                    .ref(`side_offers/${updatedItem.id}`)
                    .update(updatedItem).then(() => {
                        Swal.fire({
                            didOpen: () => {
                                Swal.hideLoading()
                            },
                            title: "Oferta actualizada",
                            text: "Se actualizaron los datos con éxito",
                            icon: "success",
                            showConfirmButton: false,
                            timer: 1000,

                        }, function () {
                            Swal.close();
                        });
                        this.nombre = "";
                        this.url = "";
                        this.order = "";
                        this.imgPc = null;
                        this.ImgMo = null;
                    }).catch((error) => {
                        ole.log('Error actualizando la oferta: ' + error);
                        Swal.fire({
                            title: 'Error',
                            text: 'Hubo un problema al actualizar la oferta. Por favor, inténtalo de nuevo.',
                            icon: 'error',
                        });
                    });
            }
            this.modalIndex = null;

        },
    },
    mounted() {
        this.fetchData();
    },
}
</script>

<style src="../styles/sideOffers.scss" lang="scss" />
